import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

const BASE_URL      = "https://senutour.com/api";
const CLOUD_NAME    = "dhs2cu6vv";
const UPLOAD_PRESET = "senutour_unsigned";

const getToken = () => localStorage.getItem("token");
const getUser  = () => JSON.parse(localStorage.getItem("user") || "{}");

// ── Icônes SVG ──────────────────────────────────────────────────
const IcGrid    = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>;
const IcMenu    = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>;
const IcCalendar= () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
const IcHistory = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
const IcStar    = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>;
const IcUpload  = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></svg>;
const IcTrash   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>;
const IcEdit    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const IcCheck   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>;
const IcX       = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcPhone   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.82 19a19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 3.09 4.18 2 2 0 0 1 5.09 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L9.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const IcUser    = () => <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.8" strokeLinecap="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;

const EQUIPEMENTS_LISTE = ["WiFi", "Climatisation", "Parking", "Terrasse", "Livraison", "Paiement Wave", "Paiement Orange Money", "Réservation en ligne", "Salle privée", "Musique live"];
const STATUT_RESA = {
  confirmee:  { label: "Confirmée",  color: "#3D6B2E", bg: "rgba(61,107,46,0.10)" },
  en_attente: { label: "En attente", color: "#C4841A", bg: "rgba(196,132,26,0.10)" },
  annulee:    { label: "Annulée",    color: "#C4441A", bg: "rgba(196,68,26,0.10)" },
};
const ONGLETS = [
  { id: "dashboard",    label: "Vue générale",         Icon: IcGrid },
  { id: "restaurants",  label: "Mes restaurants",      Icon: IcMenu },
  { id: "reservations", label: "Réservations",         Icon: IcCalendar },
  { id: "historique",   label: "Historique",           Icon: IcHistory },
  { id: "avis",         label: "Avis clients",         Icon: IcStar },
];

const FORM_VIDE = {
  nom: "", adresse: "", quartier: "", type: "Sénégalaise", ville: "Dakar",
  telephone: "", whatsapp: "", prixMoyen: "", horaires: "", description: "",
  equipements: [], reservationActive: true,
};

const Etoiles = ({ note, size = 14 }) => (
  <span>{[1,2,3,4,5].map(i => <span key={i} style={{ color: i <= note ? "#C4441A" : "#E8DCC8", fontSize: size }}>★</span>)}</span>
);

const formatPrix = (p) => p ? Number(p).toLocaleString("fr-FR") + " F" : "—";

export default function RestaurateurDashboard() {
  const navigate = useNavigate();
  const user = getUser();
  const fileInputRef = useRef();

  const [onglet, setOnglet]           = useState("dashboard");
  const [restaurants, setRestaurants] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading]         = useState(true);
  const [showForm, setShowForm]       = useState(false);
  const [editingId, setEditingId]     = useState(null); // null = création, sinon id du restaurant modifié
  const [form, setForm]               = useState(FORM_VIDE);
  const [photos, setPhotos]           = useState([]);
  const [uploading, setUploading]     = useState(false);
  const [saving, setSaving]           = useState(false);
  const [filtreStatut, setFiltreStatut] = useState("tous");
  const [restaurantActif, setRestaurantActif] = useState(null);

  useEffect(() => {
    const charger = async () => {
      try {
        const [resR, resResa] = await Promise.all([
          fetch(`${BASE_URL}/restaurants/mes-restaurants`, { headers: { Authorization: `Bearer ${getToken()}` } }),
          fetch(`${BASE_URL}/reservations/restaurateur`, { headers: { Authorization: `Bearer ${getToken()}` } }),
        ]);
        const restos = await resR.json();
        const resas  = await resResa.json();
        setRestaurants(Array.isArray(restos) ? restos : []);
        setReservations(Array.isArray(resas) ? resas : []);
        if (Array.isArray(restos) && restos.length > 0) setRestaurantActif(restos[0].id);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    charger();
  }, []);

  const handlePhotos = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    setUploading(true);
    try {
      const urls = await Promise.all(files.map(async (file) => {
        const fd = new FormData();
        fd.append("file", file);
        fd.append("upload_preset", UPLOAD_PRESET);
        const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, { method: "POST", body: fd });
        const data = await res.json();
        return data.secure_url;
      }));
      setPhotos(prev => [...prev, ...urls]);
    } catch { alert("Erreur upload photo."); }
    finally { setUploading(false); }
  };

  const toggleEquipement = (eq) => setForm(prev => ({
    ...prev,
    equipements: prev.equipements.includes(eq) ? prev.equipements.filter(e => e !== eq) : [...prev.equipements, eq],
  }));

  // ── Ouvrir le formulaire vide (nouveau restaurant) ────────────
  const ouvrirNouveauRestaurant = () => {
    setEditingId(null);
    setForm(FORM_VIDE);
    setPhotos([]);
    setShowForm(true);
  };

  // ── Ouvrir le formulaire pré-rempli (modification) ────────────
  const modifierRestaurant = (r) => {
    setEditingId(r.id);
    setForm({
      nom: r.nom || "",
      adresse: r.adresse || "",
      quartier: r.quartier || "",
      type: r.type || "Sénégalaise",
      ville: r.ville || "Dakar",
      telephone: r.telephone || "",
      whatsapp: r.whatsapp || "",
      prixMoyen: r.prixMoyen || "",
      horaires: r.horaires || "",
      description: r.description || "",
      equipements: Array.isArray(r.equipements) ? r.equipements : [],
      reservationActive: r.reservationActive ?? true,
    });
    setPhotos(Array.isArray(r.images) ? r.images : []);
    setShowForm(true);
  };

  const annulerFormulaire = () => {
    setShowForm(false);
    setForm(FORM_VIDE);
    setPhotos([]);
    setEditingId(null);
  };

  // ── Créer ou mettre à jour un restaurant ──────────────────────
  const enregistrerRestaurant = async () => {
    if (!form.nom || !form.adresse) { alert("Nom et adresse obligatoires."); return; }
    setSaving(true);
    try {
      const payload = {
        ...form,
        prixMoyen: parseInt(form.prixMoyen) || 0,
        images: photos,
        disponible: true,
      };

      const url    = editingId ? `${BASE_URL}/restaurants/${editingId}` : `${BASE_URL}/restaurants`;
      const method = editingId ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (res.ok) {
        if (editingId) {
          setRestaurants(prev => prev.map(r => r.id === editingId ? { ...r, ...(data.restaurant || payload), id: editingId } : r));
        } else {
          setRestaurants(prev => [...prev, data.restaurant]);
          if (!restaurantActif) setRestaurantActif(data.restaurant.id);
        }
        annulerFormulaire();
      } else alert(data.message || "Erreur.");
    } catch { alert("Erreur serveur."); }
    finally { setSaving(false); }
  };

  const supprimerRestaurant = async (id) => {
    if (!window.confirm("Supprimer ce restaurant ?")) return;
    await fetch(`${BASE_URL}/restaurants/${id}`, { method: "DELETE", headers: { Authorization: `Bearer ${getToken()}` } });
    setRestaurants(prev => prev.filter(r => r.id !== id));
    if (restaurantActif === id) setRestaurantActif(restaurants.find(r => r.id !== id)?.id || null);
  };

  const confirmerResa = async (id) => {
    await fetch(`${BASE_URL}/reservations/${id}/confirmer`, { method: "PATCH", headers: { Authorization: `Bearer ${getToken()}` } });
    setReservations(prev => prev.map(r => r.id === id ? { ...r, statut: "confirmee" } : r));
  };

  const annulerResa = async (id) => {
    await fetch(`${BASE_URL}/reservations/${id}/annuler`, { method: "PATCH", headers: { Authorization: `Bearer ${getToken()}` } });
    setReservations(prev => prev.map(r => r.id === id ? { ...r, statut: "annulee" } : r));
  };

  const resasAttente    = reservations.filter(r => r.statut === "en_attente");
  const resasFiltrees   = filtreStatut === "tous" ? reservations : reservations.filter(r => r.statut === filtreStatut);
  const noteGlobale     = restaurants.length ? (restaurants.reduce((s, r) => s + (r.note || 0), 0) / restaurants.length).toFixed(1) : "—";

  const labelStyle = { display: "block", fontSize: 11, fontWeight: 700, color: "#7A5A3A", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 };
  const inputStyle = { width: "100%", boxSizing: "border-box", padding: "11px 14px", border: "1.5px solid #E8DCC8", borderRadius: 10, fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, outline: "none", color: "#1C1008", background: "white" };

  if (loading) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#FAF5EC", fontFamily: "'Space Grotesk',sans-serif", color: "#7A5A3A" }}>Chargement…</div>
  );

  return (
    <>
      <Navbar />
      <div style={{ fontFamily: "'Space Grotesk',sans-serif", background: "#FAF5EC", minHeight: "100vh", color: "#1C1008" }}>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,700;0,9..144,800;1,9..144,400&family=Space+Grotesk:wght@300;400;500;600;700&display=swap');
          .onglet-btn { transition: all .2s; cursor: pointer; border: none; background: none; }
          .onglet-btn:hover { color: #C4441A !important; }
          .btn-primary { background: #C4441A; transition: background .2s; border: none; cursor: pointer; }
          .btn-primary:hover { background: #A03614; }
          .btn-success { background: #3D6B2E; transition: background .2s; border: none; cursor: pointer; }
          .btn-success:hover { background: #2D5220; }
          .card-hover { transition: all .2s; }
          .card-hover:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(28,16,8,0.10) !important; }
          .photo-zone { border: 2px dashed #E8DCC8; border-radius: 12px; padding: 32px; text-align: center; cursor: pointer; transition: border-color .2s; }
          .photo-zone:hover { border-color: #C4441A; }
          .eq-pill { cursor: pointer; transition: all .15s; user-select: none; }
          .toggle-switch { position: relative; width: 44px; height: 24px; border-radius: 12px; cursor: pointer; transition: background .2s; flex-shrink: 0; }
          .toggle-knob { position: absolute; top: 2px; width: 20px; height: 20px; border-radius: 50%; background: white; transition: left .2s; box-shadow: 0 1px 3px rgba(0,0,0,0.2); }
          @media (max-width: 767px) { .stats-grid { grid-template-columns: 1fr 1fr !important; } }
        `}</style>

        {/* ── HEADER ── */}
        <div style={{ background: "linear-gradient(135deg,#1C1008 0%,#2D1A08 100%)", padding: "48px 5% 36px", position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", inset: 0, backgroundImage: "radial-gradient(circle,rgba(196,68,26,.07) 1px,transparent 1px)", backgroundSize: "28px 28px" }} />
          <div style={{ maxWidth: 1100, margin: "0 auto", position: "relative", zIndex: 1 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 20 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
                <div style={{ width: 64, height: 64, borderRadius: "50%", background: "linear-gradient(135deg,#C4441A,#E8834A)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, fontWeight: 800, color: "white", border: "3px solid rgba(255,255,255,0.2)", flexShrink: 0, overflow: "hidden" }}>
                  {localStorage.getItem("sunutour_photo")
                    ? <img src={localStorage.getItem("sunutour_photo")} style={{ width: "100%", height: "100%", objectFit: "cover" }} alt="profil" />
                    : <IcUser />}
                </div>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#C4441A", textTransform: "uppercase", letterSpacing: 2, marginBottom: 4 }}>Dashboard Restaurateur · JOJ 2026</div>
                  <h1 style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 800, color: "white", margin: 0 }}>{user.prenom} {user.nom}</h1>
                  <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", marginTop: 3 }}>
                    {restaurants.length} restaurant{restaurants.length !== 1 ? "s" : ""} · {resasAttente.length} réservation{resasAttente.length !== 1 ? "s" : ""} en attente
                  </div>
                </div>
              </div>
              <button className="btn-primary" onClick={() => { setOnglet("restaurants"); ouvrirNouveauRestaurant(); }}
                style={{ color: "white", borderRadius: 10, padding: "12px 22px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700, display: "flex", alignItems: "center", gap: 8, boxShadow: "0 8px 20px rgba(196,68,26,0.35)" }}>
                + Ajouter un restaurant
              </button>
            </div>
          </div>
        </div>

        {/* ── ONGLETS ── */}
        <div style={{ background: "white", borderBottom: "1.5px solid #E8DCC8", padding: "0 5%", overflowX: "auto" }}>
          <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", gap: 4, minWidth: "max-content" }}>
            {ONGLETS.map(o => (
              <button key={o.id} className="onglet-btn" onClick={() => setOnglet(o.id)}
                style={{ padding: "16px 18px", fontSize: 13, fontWeight: 600, color: onglet === o.id ? "#C4441A" : "#7A5A3A", borderBottom: onglet === o.id ? "2px solid #C4441A" : "2px solid transparent", marginBottom: -1, display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}>
                <o.Icon /> {o.label}
                {o.id === "reservations" && resasAttente.length > 0 && (
                  <span style={{ background: "#C4441A", color: "white", borderRadius: "50%", width: 18, height: 18, fontSize: 10, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center" }}>{resasAttente.length}</span>
                )}
              </button>
            ))}
          </div>
        </div>

        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "36px 5% 60px" }}>

          {/* ══ VUE GÉNÉRALE ══ */}
          {onglet === "dashboard" && (
            <>
              <div className="stats-grid" style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 16, marginBottom: 32 }}>
                {[
                  { label: "Restaurants",     value: restaurants.length,        color: "#C4441A" },
                  { label: "En attente",      value: resasAttente.length,       color: "#C4841A" },
                  { label: "Total réservations", value: reservations.length,    color: "#3D6B2E" },
                  { label: "Note moyenne",    value: noteGlobale,               color: "#C4441A", suffix: "/5" },
                ].map((s, i) => (
                  <div key={i} className="card-hover" style={{ background: "white", borderRadius: 14, padding: "22px", border: "1.5px solid #E8DCC8", boxShadow: "0 2px 12px rgba(28,16,8,0.06)" }}>
                    <div style={{ fontFamily: "'Fraunces',serif", fontSize: 32, fontWeight: 800, color: s.color }}>{s.value}<span style={{ fontSize: 13 }}>{s.suffix || ""}</span></div>
                    <div style={{ fontSize: 12, color: "#7A5A3A", marginTop: 6, fontWeight: 600 }}>{s.label}</div>
                  </div>
                ))}
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
                <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                  <div style={{ padding: "18px 24px", borderBottom: "1.5px solid #E8DCC8", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#1C1008", margin: 0 }}>Mes restaurants</h3>
                    <button onClick={() => setOnglet("restaurants")} style={{ fontSize: 12, color: "#C4441A", fontWeight: 600, background: "none", border: "none", cursor: "pointer" }}>Voir tout →</button>
                  </div>
                  {restaurants.length === 0
                    ? <div style={{ padding: 32, textAlign: "center", color: "#7A5A3A", fontSize: 13 }}>Aucun restaurant — ajoutez le vôtre !</div>
                    : restaurants.slice(0, 4).map((r, i, arr) => (
                      <div key={r.id} style={{ padding: "14px 24px", borderBottom: i < arr.length - 1 ? "1px solid #F2E4C8" : "none", display: "flex", alignItems: "center", gap: 12 }}>
                        <div style={{ width: 40, height: 40, borderRadius: 8, overflow: "hidden", flexShrink: 0, background: "#F2E4C8" }}>
                          {r.images?.[0] ? <img src={r.images[0]} alt={r.nom} style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>🍽️</div>}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{r.nom}</div>
                          <div style={{ fontSize: 11, color: "#7A5A3A" }}>{r.type} · {r.ville}</div>
                        </div>
                        <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: r.disponible ? "rgba(61,107,46,0.10)" : "rgba(196,68,26,0.10)", color: r.disponible ? "#3D6B2E" : "#C4441A" }}>
                          {r.disponible ? "Ouvert" : "Fermé"}
                        </span>
                      </div>
                    ))
                  }
                </div>

                <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                  <div style={{ padding: "18px 24px", borderBottom: "1.5px solid #E8DCC8", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#1C1008", margin: 0 }}>Réservations récentes</h3>
                    <button onClick={() => setOnglet("reservations")} style={{ fontSize: 12, color: "#C4441A", fontWeight: 600, background: "none", border: "none", cursor: "pointer" }}>Voir tout →</button>
                  </div>
                  {reservations.length === 0
                    ? <div style={{ padding: 32, textAlign: "center", color: "#7A5A3A", fontSize: 13 }}>Aucune réservation</div>
                    : reservations.slice(0, 4).map((r, i, arr) => (
                      <div key={r.id} style={{ padding: "13px 24px", borderBottom: i < arr.length - 1 ? "1px solid #F2E4C8" : "none" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 3 }}>
                          <span style={{ fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{r.nomClient} {r.prenomClient}</span>
                          <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 8px", borderRadius: 20, background: STATUT_RESA[r.statut]?.bg, color: STATUT_RESA[r.statut]?.color }}>{STATUT_RESA[r.statut]?.label}</span>
                        </div>
                        <div style={{ fontSize: 11, color: "#7A5A3A" }}>{formatPrix(r.total)}</div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </>
          )}

          {/* ══ MES RESTAURANTS ══ */}
          {onglet === "restaurants" && (
            <>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24, flexWrap: "wrap", gap: 12 }}>
                <div>
                  <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Mes restaurants</h2>
                  <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>{restaurants.length} restaurant{restaurants.length !== 1 ? "s" : ""}</p>
                </div>
                <button className="btn-primary" onClick={() => (showForm ? annulerFormulaire() : ouvrirNouveauRestaurant())}
                  style={{ color: "white", borderRadius: 10, padding: "10px 20px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700 }}>
                  {showForm ? "Annuler" : "+ Ajouter un restaurant"}
                </button>
              </div>

              {showForm && (
                <div style={{ background: "white", borderRadius: 16, border: "1.5px solid #E8DCC8", padding: "32px", marginBottom: 28, boxShadow: "0 4px 20px rgba(28,16,8,0.08)" }}>
                  <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 20, fontWeight: 800, color: "#1C1008", marginBottom: 24 }}>
                    {editingId ? "Modifier le restaurant" : "Nouveau restaurant"}
                  </h3>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 20px" }}>
                    {[
                      { label: "Nom du restaurant *", key: "nom",     placeholder: "Ex: La Teranga" },
                      { label: "Adresse *",           key: "adresse", placeholder: "Ex: Avenue Cheikh Anta Diop" },
                    ].map(f => (
                      <div key={f.key} style={{ marginBottom: 16 }}>
                        <label style={labelStyle}>{f.label}</label>
                        <input value={form[f.key]} onChange={e => setForm({ ...form, [f.key]: e.target.value })} placeholder={f.placeholder} style={inputStyle} />
                      </div>
                    ))}
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0 16px" }}>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Type de cuisine</label>
                      <select value={form.type} onChange={e => setForm({ ...form, type: e.target.value })} style={inputStyle}>
                        <option>Sénégalaise</option>
                        <option>Fruits de mer</option>
                        <option>Grillades & BBQ</option>
                        <option>Café & Snacks</option>
                        <option>Fast-food</option>
                        <option>Mixte</option>
                        <option>Végétarien</option>
                      </select>
                    </div>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Ville</label>
                      <select value={form.ville} onChange={e => setForm({ ...form, ville: e.target.value })} style={inputStyle}>
                        <option>Dakar</option>
                        <option>Diamniadio</option>
                        <option>Saly</option>
                        <option>Saint-Louis</option>
                        <option>Ziguinchor</option>
                        <option>Thiès</option>
                      </select>
                    </div>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Quartier</label>
                      <input value={form.quartier} onChange={e => setForm({ ...form, quartier: e.target.value })} placeholder="Ex: Plateau, Almadies…" style={inputStyle} />
                    </div>
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0 16px" }}>
                    {[
                      { label: "Téléphone",      key: "telephone",  placeholder: "+221 77 000 00 00", type: "tel" },
                      { label: "WhatsApp",        key: "whatsapp",   placeholder: "+221 77 000 00 00", type: "tel" },
                      { label: "Prix moyen (F CFA)", key: "prixMoyen", placeholder: "Ex: 5000",        type: "number" },
                    ].map(f => (
                      <div key={f.key} style={{ marginBottom: 16 }}>
                        <label style={labelStyle}>{f.label}</label>
                        <input type={f.type} value={form[f.key]} onChange={e => setForm({ ...form, [f.key]: e.target.value })} placeholder={f.placeholder} style={inputStyle} />
                      </div>
                    ))}
                  </div>

                  <div style={{ marginBottom: 16 }}>
                    <label style={labelStyle}>Horaires</label>
                    <input value={form.horaires} onChange={e => setForm({ ...form, horaires: e.target.value })} placeholder="Ex: Lun–Sam 11h–23h, Dim 12h–22h" style={inputStyle} />
                  </div>

                  <div style={{ marginBottom: 20 }}>
                    <label style={labelStyle}>Description</label>
                    <textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value })}
                      placeholder="Décrivez votre restaurant, votre spécialité, l'ambiance…"
                      rows={4} style={{ ...inputStyle, resize: "vertical", lineHeight: 1.6 }} />
                  </div>

                  {/* ── Réservation en ligne activable/désactivable ── */}
                  <div style={{ marginBottom: 20, background: "#FAF5EC", borderRadius: 10, padding: "16px 18px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16 }}>
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 700, color: "#1C1008", marginBottom: 3 }}>Réservations en ligne</div>
                      <div style={{ fontSize: 12, color: "#7A5A3A", lineHeight: 1.5 }}>
                        {form.reservationActive
                          ? "Les clients peuvent réserver une table directement depuis SenuTour."
                          : "Les clients verront votre fiche mais devront vous contacter directement (WhatsApp/téléphone) — aucune réservation en ligne."}
                      </div>
                    </div>
                    <div className="toggle-switch" onClick={() => setForm({ ...form, reservationActive: !form.reservationActive })}
                      style={{ background: form.reservationActive ? "#3D6B2E" : "#E8DCC8" }}>
                      <div className="toggle-knob" style={{ left: form.reservationActive ? 22 : 2 }} />
                    </div>
                  </div>

                  <div style={{ marginBottom: 20 }}>
                    <label style={labelStyle}>Services & équipements</label>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                      {EQUIPEMENTS_LISTE.map(eq => (
                        <span key={eq} className="eq-pill" onClick={() => toggleEquipement(eq)}
                          style={{ padding: "6px 14px", borderRadius: 20, fontSize: 13, fontWeight: 500, border: `1.5px solid ${form.equipements.includes(eq) ? "#C4441A" : "#E8DCC8"}`, background: form.equipements.includes(eq) ? "rgba(196,68,26,0.08)" : "white", color: form.equipements.includes(eq) ? "#C4441A" : "#7A5A3A" }}>
                          {form.equipements.includes(eq) ? "✓ " : ""}{eq}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div style={{ marginBottom: 24 }}>
                    <label style={labelStyle}>Photos</label>
                    <div className="photo-zone" onClick={() => fileInputRef.current?.click()}>
                      <input ref={fileInputRef} type="file" multiple accept="image/*" onChange={handlePhotos} style={{ display: "none" }} />
                      {uploading ? <p style={{ color: "#7A5A3A", margin: 0, fontSize: 14 }}>Chargement…</p> : (
                        <><IcUpload /><p style={{ color: "#7A5A3A", margin: "8px 0 4px", fontSize: 14, fontWeight: 600 }}>Cliquez pour ajouter des photos</p><p style={{ color: "#B8A898", margin: 0, fontSize: 12 }}>JPG, PNG — plusieurs fichiers acceptés</p></>
                      )}
                    </div>
                    {photos.length > 0 && (
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 12 }}>
                        {photos.map((url, i) => (
                          <div key={i} style={{ position: "relative", width: 80, height: 80, borderRadius: 8, overflow: "hidden" }}>
                            <img src={url} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                            <button onClick={() => setPhotos(prev => prev.filter(p => p !== url))}
                              style={{ position: "absolute", top: 4, right: 4, background: "rgba(196,68,26,0.85)", border: "none", borderRadius: "50%", width: 20, height: 20, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "white" }}>
                              <IcTrash />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                    <button onClick={annulerFormulaire}
                      style={{ background: "white", border: "1.5px solid #E8DCC8", borderRadius: 10, padding: "11px 20px", fontSize: 14, fontWeight: 600, color: "#7A5A3A", cursor: "pointer" }}>
                      Annuler
                    </button>
                    <button className="btn-primary" onClick={enregistrerRestaurant} disabled={saving}
                      style={{ color: "white", borderRadius: 10, padding: "11px 28px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700, opacity: saving ? 0.7 : 1 }}>
                      {saving ? "Enregistrement…" : editingId ? "Mettre à jour" : "Enregistrer"}
                    </button>
                  </div>
                </div>
              )}

              {restaurants.length === 0 && !showForm ? (
                <div style={{ textAlign: "center", padding: 60, color: "#7A5A3A" }}>
                  <p style={{ fontSize: 15, marginBottom: 16 }}>Aucun restaurant enregistré.</p>
                  <button className="btn-primary" onClick={ouvrirNouveauRestaurant} style={{ color: "white", borderRadius: 10, padding: "12px 24px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700 }}>
                    + Ajouter mon premier restaurant
                  </button>
                </div>
              ) : (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 16 }}>
                  {restaurants.map(r => (
                    <div key={r.id} style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden", boxShadow: "0 2px 12px rgba(28,16,8,0.06)" }}>
                      <div style={{ height: 140, background: "linear-gradient(135deg,#1C1008,#2D1A08)", overflow: "hidden", position: "relative" }}>
                        {r.images?.[0] ? <img src={r.images[0]} alt={r.nom} style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 48, opacity: 0.5 }}>🍽️</div>}
                        <span style={{ position: "absolute", top: 10, right: 10, fontSize: 11, fontWeight: 700, padding: "4px 10px", borderRadius: 20, background: r.disponible ? "rgba(61,107,46,0.85)" : "rgba(196,68,26,0.85)", color: "white" }}>
                          {r.disponible ? "Ouvert" : "Fermé"}
                        </span>
                        {!r.reservationActive && (
                          <span style={{ position: "absolute", top: 10, left: 10, fontSize: 10, fontWeight: 700, padding: "4px 10px", borderRadius: 20, background: "rgba(28,16,8,0.7)", color: "white" }}>
                            Réservation désactivée
                          </span>
                        )}
                      </div>
                      <div style={{ padding: 16 }}>
                        <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 15, fontWeight: 800, color: "#1C1008", margin: "0 0 4px" }}>{r.nom}</h3>
                        <div style={{ fontSize: 12, color: "#7A5A3A", marginBottom: 6 }}>{r.type} · {r.quartier ? `${r.quartier}, ` : ""}{r.ville}</div>
                        {r.horaires && <div style={{ fontSize: 11, color: "#7A5A3A", marginBottom: 10 }}>🕐 {r.horaires}</div>}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 12, borderTop: "1px solid #F2E4C8" }}>
                          <div>
                            <div style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#C4441A" }}>{r.prixMoyen ? `~${Number(r.prixMoyen).toLocaleString()} F` : "Prix variable"}</div>
                            <div style={{ fontSize: 11, color: "#7A5A3A" }}>prix moyen</div>
                          </div>
                          <div style={{ display: "flex", gap: 8 }}>
                            <button onClick={() => modifierRestaurant(r)}
                              style={{ background: "rgba(28,16,8,0.05)", border: "none", borderRadius: 8, padding: "7px 12px", fontSize: 12, fontWeight: 600, color: "#7A5A3A", cursor: "pointer", display: "flex", alignItems: "center", gap: 5 }}>
                              <IcEdit /> Modifier
                            </button>
                            <button onClick={() => supprimerRestaurant(r.id)}
                              style={{ background: "rgba(196,68,26,0.08)", border: "none", borderRadius: 8, padding: "7px 12px", fontSize: 12, fontWeight: 600, color: "#C4441A", cursor: "pointer", display: "flex", alignItems: "center", gap: 5 }}>
                              <IcTrash /> Supprimer
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}

          {/* ══ RÉSERVATIONS ══ */}
          {onglet === "reservations" && (
            <>
              <div style={{ marginBottom: 24 }}>
                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Réservations</h2>
                <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>{reservations.length} réservation{reservations.length !== 1 ? "s" : ""}{resasAttente.length > 0 && <span style={{ color: "#C4841A", fontWeight: 700 }}> · {resasAttente.length} en attente</span>}</p>
              </div>

              <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
                {["tous", "en_attente", "confirmee", "annulee"].map(s => (
                  <button key={s} onClick={() => setFiltreStatut(s)}
                    style={{ padding: "7px 16px", borderRadius: 20, border: `1.5px solid ${filtreStatut === s ? "#C4441A" : "#E8DCC8"}`, background: filtreStatut === s ? "#C4441A" : "white", color: filtreStatut === s ? "white" : "#7A5A3A", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                    {s === "tous" ? "Toutes" : STATUT_RESA[s]?.label}
                  </button>
                ))}
              </div>

              {resasFiltrees.length === 0
                ? <div style={{ textAlign: "center", padding: 60, color: "#7A5A3A", fontSize: 14 }}>Aucune réservation</div>
                : (
                  <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                    {resasFiltrees.map(r => (
                      <div key={r.id} style={{ background: "white", borderRadius: 14, border: `1.5px solid ${r.statut === "en_attente" ? "rgba(196,132,26,0.35)" : "#E8DCC8"}`, padding: "20px 24px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 12 }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10, flexWrap: "wrap" }}>
                              <span style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#1C1008" }}>{r.nomClient} {r.prenomClient}</span>
                              <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: STATUT_RESA[r.statut]?.bg, color: STATUT_RESA[r.statut]?.color }}>{STATUT_RESA[r.statut]?.label}</span>
                            </div>
                            <div style={{ fontSize: 13, color: "#7A5A3A", marginBottom: 4 }}>📅 {r.dateArrivee} → {r.dateDepart} · {r.nbNuits} nuit{r.nbNuits > 1 ? "s" : ""}</div>
                            <div style={{ display: "flex", gap: 16, fontSize: 12, color: "#7A5A3A" }}>
                              <span style={{ display: "flex", alignItems: "center", gap: 4 }}><IcPhone /> {r.telephoneClient}</span>
                            </div>
                            {r.message && <div style={{ marginTop: 8, fontSize: 12, color: "#7A5A3A", background: "#FAF5EC", borderRadius: 8, padding: "8px 12px" }}>💬 {r.message}</div>}
                          </div>
                          <div style={{ textAlign: "right" }}>
                            <div style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 800, color: "#C4441A" }}>{formatPrix(r.total)}</div>
                            {r.statut === "en_attente" && (
                              <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 12 }}>
                                <button className="btn-success" onClick={() => confirmerResa(r.id)}
                                  style={{ color: "white", borderRadius: 8, padding: "8px 14px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", gap: 6 }}>
                                  <IcCheck /> Confirmer
                                </button>
                                <button className="btn-primary" onClick={() => annulerResa(r.id)}
                                  style={{ color: "white", borderRadius: 8, padding: "8px 14px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", gap: 6 }}>
                                  <IcX /> Refuser
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )
              }
            </>
          )}

          {/* ══ HISTORIQUE ══ */}
          {onglet === "historique" && (
            <>
              <div style={{ marginBottom: 24 }}>
                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Historique</h2>
                <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>{reservations.filter(r => r.statut === "confirmee").length} réservation{reservations.filter(r => r.statut === "confirmee").length !== 1 ? "s" : ""} confirmée{reservations.filter(r => r.statut === "confirmee").length !== 1 ? "s" : ""}</p>
              </div>
              <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                {reservations.length === 0
                  ? <div style={{ padding: 40, textAlign: "center", color: "#7A5A3A", fontSize: 14 }}>Aucune réservation pour le moment</div>
                  : (
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead>
                        <tr style={{ background: "#FAF5EC" }}>
                          {["Client", "Email", "Arrivée", "Départ", "Total", "Statut"].map(h => (
                            <th key={h} style={{ padding: "12px 20px", fontSize: 11, fontWeight: 700, color: "#7A5A3A", textTransform: "uppercase", letterSpacing: 1, textAlign: "left", borderBottom: "1.5px solid #E8DCC8" }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {reservations.map((r, i) => (
                          <tr key={r.id} style={{ borderBottom: i < reservations.length - 1 ? "1px solid #F2E4C8" : "none" }}>
                            <td style={{ padding: "14px 20px", fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{r.nomClient} {r.prenomClient}</td>
                            <td style={{ padding: "14px 20px", fontSize: 12, color: "#7A5A3A" }}>{r.emailClient}</td>
                            <td style={{ padding: "14px 20px", fontSize: 12, color: "#7A5A3A" }}>{r.dateArrivee}</td>
                            <td style={{ padding: "14px 20px", fontSize: 12, color: "#7A5A3A" }}>{r.dateDepart}</td>
                            <td style={{ padding: "14px 20px", fontFamily: "'Fraunces',serif", fontSize: 15, fontWeight: 700, color: "#3D6B2E" }}>{formatPrix(r.total)}</td>
                            <td style={{ padding: "14px 20px" }}>
                              <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: STATUT_RESA[r.statut]?.bg, color: STATUT_RESA[r.statut]?.color }}>{STATUT_RESA[r.statut]?.label}</span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )
                }
              </div>
            </>
          )}

          {/* ══ AVIS ══ */}
          {onglet === "avis" && (
            <>
              <div style={{ marginBottom: 24 }}>
                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Avis clients</h2>
                <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>Note moyenne : <strong>{noteGlobale}/5</strong></p>
              </div>
              {restaurants.length === 0
                ? <div style={{ textAlign: "center", padding: 60, color: "#7A5A3A", fontSize: 14 }}>Ajoutez d'abord un restaurant pour voir les avis.</div>
                : (
                  <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", padding: "32px", textAlign: "center" }}>
                    <div style={{ fontFamily: "'Fraunces',serif", fontSize: 56, fontWeight: 800, color: "#C4441A", lineHeight: 1 }}>{noteGlobale}</div>
                    <div style={{ margin: "12px 0 8px" }}><Etoiles note={Math.round(parseFloat(noteGlobale) || 0)} size={24} /></div>
                    <p style={{ fontSize: 13, color: "#7A5A3A" }}>Les avis seront affichés ici dès que des clients en laisseront.</p>
                  </div>
                )
              }
            </>
          )}

        </div>
      </div>
      <Footer />
    </>
  );
}